import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#D32F2F',
    secondary: '#E8E2F2',
    accent: '#B8E2F2',
    error: '#FC4161',
    info: '#C0C0C0',
    warning: '#FFA826',
    success: '#21BED5',
  },
})
